<template>
  <div>
    <section class="onLoad section">
      <Bg/>
      <div class="container logo-and-form">
        <div class="columns is-desktop">
          <div class="column logo">
            <Logo/>
          </div>
          <div class="column form">
            <Form v-on:loadCompleted="finishLoad"/>
          </div>
        </div>
      </div>
    </section>
    <BgLoading class="bg-loading" :class="{'is-visible': loading, 'is-invisible': !loading}"/>
  </div>
</template>

<script>
  // ローディング中のページ全体のレイアウト。Z indexを最大にして前に出す。CSSアニメーションか何かで背景があると嬉しい
  import Logo from './Loading/Logo.vue';
  import Form from './Loading/Form.vue';
  import Bg from './Loading/Bg.vue';
  import BgLoading from './Loading/BgLoading.vue';

  export default {
    data() {
      return {
        loading: false,
      }
    },
    props: {
      isLoadingEnd: false,
    },
    components: {
    Logo,
    Form,
    Bg,
    BgLoading
  },
  methods: {
    finishLoad() {
      this.loading = true;
      setTimeout(() => {
        this.$emit("loadCompleted");
      }, 700);
    }
    },
    mounted() {
    /*
      setTimeout(() => {
      }, 3000);
      */
    },
    name: "OnLoad"
  }
</script>

<style scoped>
  .columns {
    padding: 0;
    margin: 0;
  }

  .onLoad {
    min-height: 100vh;
    min-width: 100vw;
    z-index: 998;
    background: linear-gradient(#70ffe9, #02745d);
    padding: 0;
    margin: 0;
  }

  .logo-and-form {
    margin-top: 30vh;
    max-height: 30vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;
  }

  .form {
    opacity: 0.95;
  }

  .is-visible {
    height: 100% !important;
    transition: height 0.5s;
  }

  .is-invisible {
    height: 0 !important;
  }

  .bg-loading {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/components/OnLoad.vue